export const environment = {
  apiUrl: 'https://api.mia.lanars-stage.com/',
  apiVersion: 'v1',
  healthApiUrl: 'https://stage.health-api.mementoportal.com/',
  healthApiVersion: 'v2',
  portalApiUrl: 'https://stage-health-api.miahealth.no/',
  portalApiVersion: 'v3',
  organizationKey: 'mia',
  production: true,
  mapsPublicKey: 'AIzaSyBoH9SpF0r3ty2L1CRp37LxZduGZ3m9MlY',
  webInsightsUrl: 'https://community-insights.miahealth.no',
  webInsightsEnvironment: 'stage',
  SOCKET_URL: 'https://chats.mia.lanars-stage.com',
};